import { v4 as uuidv4 } from 'uuid'
import { type Medication, type Prescription } from './types'

export const extractMedicationsFromVisit = (visit: any): Medication[] => {
  if (
    !visit['medications(list)'] ||
    !Array.isArray(visit['medications(list)'])
  ) {
    return []
  }

  return visit['medications(list)'].map((med: any) => ({
    id: uuidv4(),
    name: med || '',
    concentration: '',
    quantity: '',
    frequency: '',
    duration: '',
    instructions: ''
  }))
}

export const createNewPrescription = (
  patientId: string,
  patientName: string,
  medications: Medication[] = []
): Prescription => {
  return {
    id: uuidv4(),
    date: new Date().toISOString(),
    patientId,
    patientName,
    medications:
      medications.length > 0 ? medications : [createEmptyMedication()]
  }
}

export const createEmptyMedication = (): Medication => {
  return {
    id: uuidv4(),
    name: '',
    concentration: '',
    quantity: '',
    frequency: '',
    duration: '',
    instructions: ''
  }
}
